import createAction from 'model/actions/utilities/createAction';
import createPassiveAction from 'model/actions/utilities/createPassiveAction';

const STATUS_METRICS = {
  status: {
    influence: 1,
    intimidation: -3,
    respect: 5
  }
};

const createLabourAction = (title, description, effect) => {
  return createAction('Continue', description, effect || (() => STATUS_METRICS), `promoted: ${title}`);
};

// Actions for each level
//improvedScavenging: true,
const scavenger = createLabourAction('Scavenger', 'efficiency in scavenging for supplies improves.');

//  "Health recovery from natural resources improved.",
const gatherer = createLabourAction('Gatherer', 'knowledge of edible and medicinal plants enhances survival.');

//"Foraging now yields more resources, sustaining you on your journey.",
//"A forager, seeking sustenance among the ruins of nature.",
//"The land, though scarred, gives forth bounty. Each foraged root, a lifeline.",
//foragingEfficiency: true
const forager = createLabourAction('Forager', 'honed the skill to forage efficiently, finding sustenance with ease.');

//"toil under the sun's gaze has toughened you, ready for the road's hardships.",
//"Increased resilience, reducing the impact of harsh conditions.",
//"A labourer, toiling under a merciless sun for scant reward.",
//"Sweat and toil under the sun's gaze hardens the spirit. The earth yields slowly to persistent hands.",
const labourer = createLabourAction('Labourer', "toil under the sun's gaze toughens the spirit.", () => ({
  status: STATUS_METRICS.status,
  resilience: 15
}));

// Provides knowledge of quick-grow techniques and portable farming, allowing the protagonist to cultivate small, fast-growing crops for sustenance on the move.
//"Cultivating barren lands, you've learned to coax life from the unforgiving earth.",
//"Your efforts in cultivation now bring greater yields, aiding your journey.",
//"A tiller, coaxing life from the barren earth.",
//"Against the stubborn soil, the tiller's efforts bear fruit. Life, tentative, breaks through.",
const tiller = createLabourAction(
  'Tiller',
  'coaxing life from the barren earth now allows growing sustenance on the move.'
);

// Unlocks the ability to perform more skilled labor in cities, leading to better-paying jobs that require less time, maximizing income during city stays.
//"Under the tutelage of masters, you learn the old crafts essential for survival.",
//"Crafting skills improved, enabling you to repair and create vital gear.",
//"The tools of trade become familiar in the apprentice's hands. Old wisdoms rekindled.",
const apprentice = createLabourAction('Apprentice', 'tools of trade become familiar. better work available');

//Offers expertise in quick, efficient repair work, enabling the protagonist to mend gear, vehicles, or temporary shelters more effectively during travels.
//'shaping stone and building shelters, you forge safety in the wilderness.'
//"Improved shelter-building skills, ensuring better rest and recovery.",
//"From stone and sweat, structures rise. A testament to resilience, a shelter against the dark.",
const mason = createLabourAction('Mason', 'from stone and sweat, structures rise. better gear and shelter');

// Grants the skill to craft or repair higher-quality tools and makeshift weapons on the road, improving survival and defensive capabilities.
//"From raw ore to tool and weapon, your forge lights the dark with promise.",
//"Smithing skills enhanced, allowing you to craft superior items.",
//"The forge, a beacon in the dark. From raw ore, tools and weapons take shape.",
//"In the forge's fire, metal is reborn. Tools and weapons, strength and protection wrought by flame.",
const smith = createLabourAction('Smith', "in the forget's fire, metal is reborn. tools and weapons wrought by flame.");

// Enhances ingenuity in creating temporary structures or fortifications, providing safer rest stops and improving chances of survival in hostile environments.
// "erecting bastions against the darkness, you offer hope in desolation.",
//"Construction projects now bolster morale and provide strategic benefits.",
//"Where once there was emptiness, now stand defenses. A bulwark against the night.",
// TODO: improved morale
const builder = createLabourAction('Builder', 'erecting bastions against the darkness.');

// Achieves mastery in a chosen craft, allowing the protagonist to create unique items or services highly sought after in cities, significantly increasing earning potential and trade value.
//"mastering the ancient arts, a beacon in the wasteland. improved gear and morale.",
//"Craftsmanship at its peak, creating items of great value and utility.",
//"The craftsman's hands weave magic from the mundane. In creation, a light against the encroaching gloom.",
// TODO:. improved gear and morale."
const craftsman = createLabourAction('Craftsman', "the craftsman's hands weave magic from the mundane");

const passiveLabour = amount =>
  createPassiveAction({
    resources: {
      health: -amount,
      coins: amount,
      food: amount,
      water: amount
    }
  });

// Export the actions
export { apprentice, builder, craftsman, forager, gatherer, labourer, mason, passiveLabour, scavenger, smith, tiller };
